module.exports = class Store {
  constructor(confs = {}) {
    this.state = {};
    Object.keys(confs).forEach(key => {
      Object.defineProperty(this.state, key, {
        enumerable: true, // 允许被枚举
        get: () => {
          return this.get(key);
        },
        set: (value) => {
          return this.set(key, value)
        },
      });
    });
    Object.defineProperty(this, '_confs', {
      enumerable: false,
      value: JSON.parse(JSON.stringify(confs))
    });
  }

  get(key) {
    return this._confs[key];
  }

  set(key, value) {
    console.log(`【发布者】触发所有订阅了${key}变化的事件`);
    this._confs[key] = value;
  }
}